import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function LogoutPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // If user is still authenticated, this means they just landed here
    // The logout should have already been triggered by Okta
    // Just clear any local state if needed
  }, []);

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(180deg, #0a1628 0%, #1a237e 30%, #4a148c 70%, #880e4f 100%)',
        color: 'white',
        padding: '24px',
      }}
    >
      <div
        style={{
          maxWidth: '500px',
          textAlign: 'center',
          background: 'rgba(255, 255, 255, 0.1)',
          padding: '48px 32px',
          borderRadius: '12px',
          backdropFilter: 'blur(10px)',
        }}
      >
        <div style={{ fontSize: '3rem', marginBottom: '24px' }}>👋</div>
        <h1 style={{ fontSize: '2rem', marginBottom: '16px', fontWeight: 600 }}>
          You've been signed out
        </h1>
        <p style={{ fontSize: '1.1rem', marginBottom: '32px', opacity: 0.9 }}>
          Thank you for using the BRG Management System. Your session has ended.
        </p>
        <button
          onClick={handleLoginClick}
          style={{
            background: '#0078d4',
            color: 'white',
            border: 'none',
            padding: '12px 32px',
            fontSize: '1rem',
            fontWeight: 500,
            borderRadius: '6px',
            cursor: 'pointer',
            transition: 'background 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#005a9e';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#0078d4';
          }}
        >
          Sign In Again
        </button>
      </div>
    </div>
  );
}
